import React, { useState } from "react";
import useStore from "../../useStore";
import { useNavigate } from "react-router-dom";
import style from "./RegistroNuevo.module.css";
import { IoMdCloseCircle } from "react-icons/io";
import logoIsotipo from "../../assests/imagenes/logo_isotipo.png";
import { RotatingLines } from "react-loader-spinner";
import { iniciarSesion } from "../../repositorios/apiServer";

import { crearUsuario } from "../../repositorios/apiServer";

export default function Login() {
  /*   const userToken = useStore((state) => state.userToken);

  const [cargando, setCargando] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    pass: "",
  });

 */

  ///###################################
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const setUserToken = useStore((state) => state.setUserToken);
  const [mensaje, setMensaje] = useState(null);
  ///###################################

  /*  const manejadorCambio = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (mensaje) setMensaje(null);
  };

  const icono_cerrar = () => {
    navigate("/carta");
  };

  const ir_registro = () => {
    navigate("/registro");
  };

  const enviarCambio = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.pass) {
      setMensaje({
        tipo: "error",
        texto: "Por favor completa todos los campos",
      });
      return;
    }

    try {
      setCargando(true);

      const response = await iniciarSesion({
        email: formData.email,
        pass: formData.pass,
      });

      if (response && response.token) {
        setUserToken(response.token);

        setTimeout(() => {
          setCargando(false);
          navigate("/carta");
        }, 2000);
      } else {
        setCargando(false);
        setMensaje({
          tipo: "error",
          texto: "Credenciales incorrectas",
        });
      }
    } catch (error) {
      console.error("Error en login:", error);
      setCargando(false);
      setMensaje({
        tipo: "error",
        texto: "Ocurrió un error al iniciar sesión",
      });
    }
 */
  ///###################################

  const ir_registro = () => {
    navigate("/registro");
  };

  const icono_cerrar = () => {
    navigate("/carta");
  };

  const ir_login = () => {
    navigate("/login");
  };

  function handleCambioNombre(e) {
    const { value } = e.target;
    setNombre(value);
    if (error) setError(null);
  }

  function handleCambioEmail(e) {
    const { value } = e.target;
    setEmail(value);
    if (error) setError(null);
  }

  function handleCambioPass(e) {
    const { value } = e.target;
    setPass(value);
    if (error) setError(null);
  }

  async function crearUsuarioForm(e) {
    e.preventDefault();

    if (!nombre || !email || !pass) {
      setError("Todos los campos son obligatorios");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("El email no es válido");
      return;
    }

    if (pass.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    try {
      setLoading(true);
      const res = await crearUsuario({
        nombre,
        email,
        pass,
      });

      if (res && res.token) {
        setLoading(false);
        setUserToken(res.token);
        
        const redirectURL = localStorage.getItem('redirectAfterLogin');
        if (redirectURL) {
          localStorage.removeItem('redirectAfterLogin');
          navigate(redirectURL, { replace: true });
        } else {
          navigate("/carta");
        }
      } else {
        setLoading(false);
        setError("Error al crear el usuario. Inténtalo de nuevo.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error al crear usuario:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message);
      } else {
        setError("Error al crear el usuario. Inténtalo de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className={style.principal_registro}>
      <div className={style.div_imagen}>
        <IoMdCloseCircle className={style.icono} onClick={icono_cerrar} />
      </div>
      <div className={style.contenedorLogo}>
        <img src={logoIsotipo} alt="logo" className={style.logoRomana} />
      </div>
      <div className={style.contenido}>
        <form
          className={style.form_registro}
          onSubmit={crearUsuarioForm}
          method="POST"
        >
          <div className={style.form_content}>
            <div className={style.campo}>
              <label htmlFor="nombre" className="label">
                Nombre
              </label>
              <input
                className={style.formato_inputs}
                type="text"
                name="nombre"
                value={nombre}
                onChange={handleCambioNombre}
                placeholder="Escribe aquí tu nombre."
                disabled={loading}
                required
              />
            </div>

            <div className={style.campo}>
              <label htmlFor="email" className="label">
                Email
              </label>
              <input
                className={style.formato_inputs}
                type="email"
                name="email"
                value={email}
                onChange={handleCambioEmail}
                placeholder="Escribe aquí tu email."
                disabled={loading}
                required
              />
            </div>

            <div className={style.campo}>
              <label htmlFor="pass" className="label">
                Contraseña
              </label>
              <input
                className={style.formato_inputs}
                type="password"
                name="pass"
                value={pass}
                onChange={handleCambioPass}
                placeholder="Escribe aquí tu contraseña. Mínimo 6 caracteres"
                disabled={loading}
                required
              />
            </div>

            {mensaje && (
              <p
                style={{
                  color: mensaje.tipo === "error" ? "red" : "green",
                  textAlign: "center",
                  margin: "10px 0",
                }}
              >
                {mensaje.texto}
              </p>
            )}

            <div className={style.botones_container}>
              {loading && (
                <RotatingLines
                  visible={true}
                  height="52"
                  width="52"
                  color="grey"
                  strokeWidth="3"
                  strokeColor="#997623"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "20px 0",
                  }}
                />
              )}
            </div>

            <div className={style.botones_container}>
              <button className={style.boton_registrar} type="submit">
                Registrarse
              </button>
            </div>
          </div>
        </form>
        <span className={style.texto}>
          ¿Tienes cuenta?{" "}
          <span
            onClick={ir_login}
            style={{ cursor: "pointer", fontWeight: "bold", marginLeft: "5px" }}
          >
            Logueate
          </span>{" "}
        </span>
      </div>
    </section>
  );
}